document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-form').forEach((form) => {
    const variantData = form.querySelector('[data-product-variants]');
    const idSelect = form.querySelector('select[name="id"]');
    const submit = form.querySelector('[name="add"]');
    if (!variantData || !idSelect || !submit) return;

    let variants = [];
    try { variants = JSON.parse(variantData.textContent); } catch (_) { return; }

    form.querySelectorAll('input[name^="options["]').forEach((input) => {
      input.addEventListener('change', () => {
        const selected = Array.from(form.querySelectorAll('input[name^="options["]:checked')).map((option) => option.value);
        const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
        if (!variant) return;
        idSelect.value = String(variant.id);
        const selectedOption = idSelect.options[idSelect.selectedIndex];
        const formattedPrice = selectedOption?.dataset.price || '';
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? `Add to bag${formattedPrice ? ` · ${formattedPrice}` : ''}` : 'Sold out';
        form.querySelectorAll('.swatch').forEach((swatch) => swatch.classList.toggle('swatch--active', swatch.querySelector('input').checked));

        const productPage = form.closest('.product-page');
        const offerPricing = productPage?.querySelector('[data-offer-pricing]');
        if (offerPricing && selectedOption) {
          offerPricing.querySelector('[data-offer-current]').textContent = formattedPrice;
          offerPricing.querySelector('[data-offer-compare]').textContent = selectedOption.dataset.comparePrice || '';
          offerPricing.querySelector('[data-offer-saving]').textContent = `Save ${selectedOption.dataset.saving} · ${selectedOption.dataset.savingPercent}% off`;
          offerPricing.hidden = !(variant.compare_at_price > variant.price);
        }

        const stockNotice = productPage?.querySelector('[data-offer-stock]');
        if (stockNotice && selectedOption) {
          const stock = Number(selectedOption.dataset.inventoryQuantity || 0);
          const threshold = Number(stockNotice.dataset.stockThreshold || 8);
          const tracked = selectedOption.dataset.inventoryTracked === 'true';
          const limited = selectedOption.dataset.inventoryPolicy === 'deny';
          stockNotice.hidden = !(variant.available && tracked && limited && stock > 0);
          const message = stockNotice.querySelector('[data-offer-stock-message]');
          if (message) message.textContent = stock <= threshold ? `Only ${stock} left at this price` : 'Seasonal offer · limited stock available';
        }
      });
    });
  });

  document.querySelectorAll('.qty').forEach((quantity) => {
    const input = quantity.querySelector('input[type="number"]');
    if (!input) return;
    quantity.querySelector('[data-qty-minus]')?.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) - 1); });
    quantity.querySelector('[data-qty-plus]')?.addEventListener('click', () => { input.value = Number(input.value || 1) + 1; });
  });

  document.querySelectorAll('[data-auto-submit]').forEach((select) => {
    select.addEventListener('change', () => select.form?.requestSubmit());
  });

  document.querySelectorAll('[data-gallery-src]').forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const mainImage = document.querySelector('[data-product-main-media] img');
      if (!mainImage) return;
      mainImage.src = thumbnail.dataset.gallerySrc;
      mainImage.removeAttribute('srcset');
      document.querySelectorAll('[data-gallery-src]').forEach((item) => item.setAttribute('aria-pressed', String(item === thumbnail)));
    });
  });
});
